const VARIANTS = [
  { A: [0, -3], B: [2, 1], C: [0, 2], area: 5, center: [0, -0.5] },
  { A: [0, -1], B: [2, 0], C: [0, 4], area: 5, center: [0, 1.5] },
  { A: [0, -4], B: [6, 0], C: [0, 9], area: 39, center: [0, 2.5] },
  { A: [0, -1], B: [3, 0], C: [0, 9], area: 15, center: [0, 4] },
  { A: [0, -4], B: [4, 0], C: [0, 4], area: 16, center: [0, 0] },
  { A: [2, -3], B: [4, 1], C: [2, 2], area: 5, center: [2, -0.5] },
  { A: [-2, -1], B: [0, 0], C: [-2, 4], area: 5, center: [-2, 1.5] },
  { A: [1, -9], B: [7, 0], C: [1, 4], area: 39, center: [1, -2.5] },
];

export function getCoordinateTriangle(original) {
  return original ? VARIANTS[0] : VARIANTS[Math.floor(Math.random() * VARIANTS.length)];
}

export function pointLatex(point) {
  const coordinateLatex = (value) => {
    if (Number.isInteger(value)) return String(value);

    for (let denominator = 2; denominator <= 12; denominator += 1) {
      const numerator = Math.round(value * denominator);
      if (Math.abs(value - numerator / denominator) < 1e-9) {
        const sign = numerator < 0 ? "-" : "";
        const absoluteNumerator = Math.abs(numerator);
        const numeratorLatex = absoluteNumerator < 10 ? String(absoluteNumerator) : `{${absoluteNumerator}}`;
        const denominatorLatex = denominator < 10 ? String(denominator) : `{${denominator}}`;
        return `${sign}\\frac${numeratorLatex}${denominatorLatex}`;
      }
    }

    return String(Number(value.toFixed(4))).replace(".", "{,}");
  };

  return `(${coordinateLatex(point[0])},${coordinateLatex(point[1])})`;
}
